export default __webpack_public_path__ + "static/media/Logo-LTHM_900x900.efca5b39.jpg";